import * as yup from 'yup';
import { ReminderStatusEnum } from 'redux-store/api/selections';
import { categoryNumberValidator, costCodeNumberValidator } from 'utils/validators';

export const AddLocationSchema = yup.object({
  title: yup.string().max(50).required(),
});

export const CostCodeCategorySchema = yup.object({
  name: yup.string().nullable().required('Required field'),
  number: categoryNumberValidator,
});

export const CostCodeSchema = (isEdit?: boolean) =>
  yup.object({
    costCodeId: isEdit ? yup.number().integer().required() : yup.number().notRequired(),
    categoryId: yup.number().nullable().required('Required field'),
    number: costCodeNumberValidator,
    name: yup.string().nullable().required('Required field'),
    budget: yup.string().nullable().required('Required field'),
  });
